import { AppointmentBodyObservable } from '@/taskpane/events/observers/appointment-body-observer'
import { AppointmentTimeObservable } from '@/taskpane/events/observers/appointment-time-observer'
import { AttachmentsObservable } from '@/taskpane/events/observers/attachment-observer'
import { IOfficeObservable } from '@/taskpane/events/observers/office-observable'
import { RecipientsObservable } from '@/taskpane/events/observers/recipients-observer'
import { SubjectObservable } from '@/taskpane/events/observers/subject-observer'
import { EmailBodyObservable } from '../events/observers/email-body-observer'

export default class ComposeInfoState {
  observersInitialized: boolean = false
  observerIntervals: ReturnType<typeof setInterval>[] = []
  bodyBeforeTemplate: string = ''
  itemId: string = ''
  immutableId: string = ''

  private observables: IOfficeObservable[]
  subject: SubjectObservable = new SubjectObservable()
  recipients: RecipientsObservable = new RecipientsObservable()
  emailBody: EmailBodyObservable = new EmailBodyObservable()
  attachments: AttachmentsObservable = new AttachmentsObservable()
  appointmentBody: AppointmentBodyObservable = new AppointmentBodyObservable()
  appointmentTime: AppointmentTimeObservable = new AppointmentTimeObservable()

  constructor() {
    this.observables = [this.subject, this.recipients, this.attachments, this.appointmentBody, this.appointmentTime, this.emailBody]
  }

  resetState() {
    for (const observeable of this.observables) {
      observeable.detachAll()
    }

    for (const observer of this.observerIntervals) {
      clearInterval(observer)
    }
    this.observerIntervals = []
    this.observersInitialized = false
    this.bodyBeforeTemplate = ''
    this.itemId = ''
    this.immutableId = ''
  }

  initializeComposeInterval() {
    this.observersInitialized = true

    for (const observeable of this.observables) {
      const interval = setInterval(() => {
        observeable.check()
      }, observeable.interval)

      this.observerIntervals.push(interval)
    }
  }
}
